const users = [
  {
    charge: 5,
    type: 'add',
    list: [
      'LU1126aaefb4e2ed7d054faa014ba08929-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Salinee Salie"
      'LU5c637c557525e27373dcd1199218cf89-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Nuiii"
      'LU5b8e7c81a936da6b02ecc3ae06913b14-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Mukjy🌟ʎɾʞnɯ"
      'LUb862a8452948cf6a841c2e758e82e492-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "boom@ipp"
      'LU0f642415ee0c8a9fb1890df3b55c8ef9-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "NGAM MAITREE PAPER"
      'LUea0cee9e56fcf56980b9c661c9a3368a-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Peung"
      'LU0f6f36c165dd0800f8e7ec1a934af43c-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Meghan 🤍💛🦜"
      'LU73cf1536c3a3f3c6a0056e2b596aac3e-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "SomSom"
      'LU39d20b162fa8e947c34f6150311324f3-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Anongprapa_Song"
      'LUcd3bacd08d14fc66e18ff55fec369628-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "3)พี่แนนชยาภัสร์"
      'LU79ee963379aae5e9d0fb0a9186b84d92-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "3] สมจิตต์พี่เค็ง"
      'LU36e0bb66bfc9c90e89dde8ce4925cfcd-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // Rada1565
      'LU35574486f977a5a7874f077297596b17-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946' // ★♡♣ Ja Oa+ ☆♥♧
    ]
  },
  {
    charge: 10,
    type: 'add',
    list: [
      'Uf9ff09b9d0238e5ff3c5cb9715f1a0a4__102459484852582', // SkyK9 ใน NVBB TEST
      'LU60e6810dd479e85f381785fa1a155c2b-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "sassyfang"
      'LUa8ddc758f2be5b35e312b2940282f829-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "SkyK9"
      'LU16bda07952b19d5fdd755f92b5299495-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946' // "Paperpress.Ying"
    ]
  },
  {
    charge: 20,
    type: 'add',
    list: [
      'LU2325a117dff6700d82e6e246db581391-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "AEKK"
      'LU608267db7b98438007bcf27ee8cd8026-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "yumi"
      'LU53a6d6cb873c715083c3cb197c04f25c-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Jirapa (Oui)"
      'LUa761831fdfb84a272db70a22d2a668ce-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "ดร.สุวลักษณ์"
      'LU2babf614b1d31393f2a3447e89f45821-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946' // "3] พี่แนน อนุษณา"
    ]
  },
  {
    charge: 50,
    type: 'fix',
    list: [
      'LU29a389eb0c1c07eec5ffa7bbbc063444-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Alisa meow"
      'LU5c28456e567ba7158041b0bd4ca10854-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "💖Add : Malee💕"
      'LU9a2d945d94677f594ee7e099e3cea8f5-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Tae ลภัสรดา 🌺"
      'LU5ee0976a66c5635352029062b81fc8f7-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "พรรณี"
      'LU149171576c49998c0560f3d842369d1d-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Janza44"
      'LU28d460949b1efead62456fcb372edaaf-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946', // "Bell🍫"
      'LUeca33e86ab8b82f2508d6a250e7c4d22-U3cf76bf4cd669bc6890c940da267a0ec__102438735480946' // "NEE"
    ]
  }
]

export default {
  checkPrice(userid) {
    let user = users.find((el) => {
      return el.list.includes(userid)
    })

    return user
  }
}
